import styled from "styled-components";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { GenericDropdownItem } from "@sonder/ui/source/styled/fragments/GenericDropdownItem";

export const ButtonList = styled.div`
  box-sizing: border-box;
  overflow-y: auto;
  display: inline-flex;
  flex-direction: column;
  max-height: 15rem;

  ${Button}, ${GenericDropdownItem} {
    flex-shrink: 0;
  }
`;
